<template lang="pug">
  .b2b-table-accountingclose-draft

    b2b-filters-accountingclose-draft(
      :filter-options='options')

    ods-table(
      :data='accountingCloseDraft.tableData',
      :default-sort="{prop: 'startDate', order: 'descending'}",
      style='width: 100%',
      @sort-change="orderOnServer",
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='projectName',
        :label='$t("accounting_closes.entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowServiceAccountingCloseDraft',
        sortable='')
      ods-table-column(
        prop='buyerName',
        :label='$t("accounting_closes.entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowBuyerAccountingCloseDraft')
      ods-table-column(
        prop='name',
        :label='$t("accounting_closes.entity_table.name")',
        :show-overflow-tooltip='true',
        v-if='isShowNameAccountingCloseDraft',
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("accounting_closes.entity_table.status")',
        :show-overflow-tooltip='true',
        v-if='isShowStatusAccountingCloseDraft',
        :formatter='formatterStatus')
      ods-table-column(
        prop='startDate',
        :label='$t("accounting_closes.entity_table.start_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowStartDateAccountingCloseDraft',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='endDate',
        :label='$t("accounting_closes.entity_table.end_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowEndDateAccountingCloseDraft',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='childAccountingCloseName',
        :label='$t("accounting_closes.entity_table.child_accounting_close_name")',
        :show-overflow-tooltip='true',
        v-if='isShowChildNameAccountingCloseDraft')
        template(slot-scope='scope')
          span.blue-text(style='cursor: pointer;',v-if='scope.row.childAccountingCloseName')
            a(
              @click='goToDetail(scope.row.childAccountingCloseId)'
            )
              | {{ scope.row.childAccountingCloseName }}
      //- Ocultas por defecto
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')

    ods-row.b2b-table-accountingclose-draft__pagination()
      ods-col.b2b-table-accountingclose-draft__pagination--left(:span='4')
      //- Paginación Tabla
      ods-col.b2b-table-accountingclose-draft__pagination--right(:span='24')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='accountingCloseDraft.totalAccountingCloseDraft')

    //- Cierres Contables Seleccionados
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersAccountingCloseDraft from '@/views/cierrescontablesborradores/B2bFiltersAccountingCloseDraft'
import B2bTableMenuAccountingCloseDraft from '@/views/cierrescontablesborradores/B2bTableMenuAccountingCloseDraft'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-cierrescontables-borradores'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-accountingclose-draft',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'accountingCloseDraft',
      'queryAccountingCloseDraft',
      'isShowServiceAccountingCloseDraft',
      'isShowBuyerAccountingCloseDraft',
      'isShowNameAccountingCloseDraft',
      'isShowStartDateAccountingCloseDraft',
      'isShowEndDateAccountingCloseDraft',
      'isShowStatusAccountingCloseDraft',
      'isShowChildNameAccountingCloseDraft'
    ])
  },

  components: {
    'b2b-filters-accountingclose-draft': B2bFiltersAccountingCloseDraft,
    B2bTableMenuAccountingCloseDraft,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getAccountingClosesDraft',
      'getOptionsService',
      'queryAccountingCloseDraftState',
      'optionsServicesEnabledState'
    ]),

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }

        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'DESC'
        }

        if (!prop) {
          prop = 'id'
        }
        stringSort = prop + ',' + order
        this.queryAccountingCloseDraft.sort = stringSort
        await this.queryAccountingCloseDraftState(this.queryAccountingCloseDraft)
        dataQuery.query = this.queryAccountingCloseDraft
        const response = await this.getAccountingClosesDraft(dataQuery)
        this.totalResults = response.totalAccountingCloseDraft
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    /* Ir al detalle */
    handleGoDetail () {
      sessionStorage.setItem('accountingName', this.currentRow.name)
      router.push({
        name: 'borradorcierre-detail',
        params: {
          draftId: this.currentRow.id,
          accountingName: this.currentRow.name
        }
      })
    },
    async goToDetail (accountingCloseId) {
      console.log('Go to detail: ', accountingCloseId)
      sessionStorage.setItem('accountingName', this.currentRow.name)

      router.push({
        name: 'cierre-detail',
        params: {
          draftId: accountingCloseId,
          accountingName: this.currentRow.name
        }
      })
    },
    formatterStatus (row, column) {
      return this.$t('status_accounting_close.' + row[column.property])
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuAccountingCloseDraft />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = { query: {} }
        this.queryAccountingCloseDraft.size = val
        await this.queryAccountingCloseDraftState(this.queryAccountingCloseDraft)
        dataQuery.query = this.queryAccountingCloseDraft
        const response = await this.getAccountingClosesDraft(dataQuery)
        this.totalResults = response.totalAccountingCloseDraft
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = { query: {} }
        this.queryAccountingCloseDraft.page = val - 1
        await this.queryAccountingCloseDraftState(this.queryAccountingCloseDraft)
        dataQuery.query = this.queryAccountingCloseDraft

        const response = await this.getAccountingClosesDraft(dataQuery)
        this.totalResults = response.totalAccountingCloseDraft
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = this.$i18n.messages.es.error.e404
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$i18n.messages.es.error.e500
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      if (!error.data.message) { error = { data: { message: errorSms } } } else { error.data.message = errorSms }
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = { query: {} }
      this.options = filters.filters

      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC' }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsServicesEnabledState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryAccountingCloseDraft.projectId = optionsFilterService[0].id
      }
      dataQuery.query = this.queryAccountingCloseDraft
      const response = await this.getAccountingClosesDraft(dataQuery)
      this.totalResults = response.totalAccountingCloseDraft
      this.currentPage = response.number + 1
    } catch (error) {
      console.log('getAccountingClosesDraft CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}

</script>

<style lang="scss" scoped>
.b2b-table-accountingclose-draft {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    span.blue-text {
      color: var(--color-bg-interactive);
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
